import Props from "./Props";

const ENV: Props = {
	API_URL: "https://service.uat.ridevu.com",
	MASTER_API_KEY: "75-5-ab2ef",
	SENTRY_LOG_URL: "https://57b844f9bd4649acb4af143f8dd52e34@o4504099501178880.ingest.sentry.io/4504099504848897",
	UNLEASH_PROXY_URL: "https://unleash-proxy.uat.privilegemovies.com/proxy",
	UNLEASH_AUTH_KEY: "oiZwZnLPMVRrCbqdzKD4kAwbWtW9aoue",
	MAINTENANCE_CONFIG_URL: "https://cf.privilegemovies.com/remote-config/uat.json",
	MOBILE_PAYMENT_URL: "https://payments.uat.ridevu.com/purchase",
	PINPOINT_REGION: "us-east-2",
	PINPOINT_APP_ID: "ridevumbz-uat",
	PINPOINT_WEB_CLIENT_ID: "f0e507e3aa754d66abfe0e3fd8891ebb",
	PINPOINT_USER_POOL_ID: "us-east-2_f0e507e3aa754d66abfe0e3fd8891ebb",
	PINPOINT_IDENTITY_POOL_ID: "us-east-2:8dca2982-6dba-43c5-9ad8-34e374cc65e7",
};

export default ENV;
